angular.module('dealerware.web.data').factory('DealerwareRoleCollection',function(Model,Collection) {

    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/roles',
        model: 'DealerwareRoleModel',
        rootNode: 'roles',
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true
            }
        },
        responseTransforms: new function() {
            this.index = function(args, data) {
                data.forEach(function(role, idx) {
                    role.data.selected = false;
                    role.data.displayName = role.data.name.replace(/_/g, ' ')
                        .replace(/\w\S*/g, function(s) {
                            return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
                        })
                        .replace(/^User Manager$/, 'Employee Manager')
                        .replace(/^User Role Manager$/, 'Employee Role Manager')
                        .replace(/^Cms$/, 'CMS')
                        .replace(/^Customer Confirmer/, 'Employee Confirmer')
                        .replace(/^Dnr/, 'DNR');
                });
            };
        }
    });

    return collection;
});
